import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { CTAButton } from './CTAButton';
import { ShieldCheckIcon, ClockIcon, ZapIcon } from 'lucide-react';
export function Offer() {
  return <SectionWrapper id="oferta" className="bg-coral-light/30" data-id="element-138">
      <div className="bg-white rounded-3xl shadow-xl overflow-hidden border border-coral/10" data-id="element-139">
        <div className="p-8 md:p-12 text-center" data-id="element-140">
          <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-4" data-id="element-141">
            Recupera el control de tu cuerpo hoy mismo.
          </h2>
          <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto" data-id="element-142">
            Por el precio de una cena, obtén el mapa exacto para terminar con la
            inflamación abdominal de una vez por todas.
          </p>

          <div className="flex flex-col md:flex-row items-center justify-center gap-8 mb-10" data-id="element-143">
            <img src="https://cdn.magicpatterns.com/uploads/g9G8Hf4zV8CMRpUSrDsS1T/Vientre_Plano_402B.png" alt="Protocolo Vientre Plano 40+" className="w-48 md:w-64 rounded-lg shadow-md" data-id="element-144" />
            <div className="text-center md:text-left" data-id="element-145">
              <div className="inline-block bg-coral text-white text-xs font-bold uppercase tracking-wider px-3 py-1 rounded-full mb-3" data-id="element-146">
                Oferta por tiempo limitado
              </div>
              <p className="text-gray-500 uppercase tracking-wider font-semibold text-sm mb-2" data-id="element-147">
                Inversión Total
              </p>
              <div className="flex items-baseline gap-3 justify-center md:justify-start mb-1" data-id="element-148">
                <span className="text-2xl md:text-3xl text-gray-400 line-through font-semibold" data-id="element-149">
                  $27.00
                </span>
                <span className="text-xs font-bold text-green-600 bg-green-100 px-2 py-1 rounded" data-id="element-150">
                  -76%
                </span>
              </div>
              <div className="text-5xl md:text-6xl font-bold text-coral mb-2" data-id="element-151">
                $6.39 <span className="text-2xl text-gray-500" data-id="element-152">USD</span>
              </div>
              <p className="text-gray-600 font-medium" data-id="element-153">
                Pago único · Acceso de por vida
              </p>
            </div>
          </div>

          <CTAButton className="w-full md:w-auto md:px-12 py-5 text-xl mb-8" data-id="element-154">
            ¡SÍ, QUIERO MI VIENTRE PLANO 40+ AHORA!
          </CTAButton>

          <div className="flex flex-col sm:flex-row justify-center items-center gap-6 text-sm text-gray-600 font-medium" data-id="element-155">
            <div className="flex items-center gap-2" data-id="element-156">
              <ZapIcon className="w-5 h-5 text-yellow-500" data-id="element-157" />
              Acceso instantáneo
            </div>
            <div className="flex items-center gap-2" data-id="element-158">
              <ShieldCheckIcon className="w-5 h-5 text-green-500" data-id="element-159" />
              Pago 100% seguro
            </div>
            <div className="flex items-center gap-2" data-id="element-160">
              <ClockIcon className="w-5 h-5 text-blue-500" data-id="element-161" />
              Material para siempre
            </div>
          </div>
        </div>
      </div>
    </SectionWrapper>;
}